import React, { createContext, useContext, useEffect, useState } from 'react';
import { initialize } from 'launchdarkly-js-client-sdk';
import { LDConfig } from '../utils/launchDarklyConfig';

interface LaunchDarklyContextData {
  isReady: boolean;
  flags: {
    caduLogin: boolean;
  };
}

const LaunchDarklyContext = createContext<LaunchDarklyContextData>({} as LaunchDarklyContextData);

export const useLDVariants = () => useContext(LaunchDarklyContext);

export const LaunchDarklyProvider: React.FC = ({ children }) => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const [caduLogin, setCaduLogin] = useState<boolean>(false);


  async function Initialize() {
    const clientEnviroment = await LDConfig.getLoginEnviroment();
    const clientKey = LDConfig.getEnviromentKey(clientEnviroment);
    const relayUrl = await LDConfig.GetRelayBaseUrl(clientEnviroment);

    let user = { key: window.location.origin };

    if (window.location.hostname === 'localhost') {
      user = { key: 'https://portal-uat5.smiles.com.br' };
    }

    const ldclient = initialize(clientKey, user, {
      baseUrl: relayUrl,
      eventsUrl: relayUrl,
      streamUrl: relayUrl,
    });

    ldclient.on('ready', () => {
      const preRegisterVariation = ldclient.variation('boo-front-cadulogin', false);

      setCaduLogin(preRegisterVariation);
      setIsReady(true);
    });
  }

  useEffect(() => {
    Initialize();
  }, []);

  const flags = {
    caduLogin,
  };

  return isReady ? (
    <LaunchDarklyContext.Provider value={{ isReady, flags }}>{children}</LaunchDarklyContext.Provider>
  ) : (
    <></>
  );
};
